import { styled } from '@mui/material';

export const UploadSidebar = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));

export const UploadCardsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5),
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  rowGap: theme.spacing(1),
}));
